export default "__VITE_ASSET__CgcNmen2__"